export default "__VITE_ASSET__JvpXYMSv__"